import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';

import { FieldPathActionAvailability } from '@/gql/graphql';

export type CustomFieldDefinitionActionAvailability =
  FieldPathActionAvailability;

const GetFieldset = graphql(`
  query Fieldset($id: ID!) {
    fieldset(id: $id) {
      id
      identifier
      isRequired
      label
      type
      archivedAt
      options
      schema
      actionAvailability {
        fieldPath
        isDestructivelyUpdateable {
          reasons
          result
        }
        optionsInUse {
          option
          reasons
        }
      }
    }
  }
`);

const useGetFieldset = (customFieldId: string | undefined) => {
  const { data, ...rest } = useQuery({
    queryKey: ['customField', customFieldId],
    queryFn: () => {
      if (!customFieldId) {
        throw new Error('Custom field ID is required');
      }
      return gqlClient.request(GetFieldset, {
        id: customFieldId,
      });
    },
    enabled: !!customFieldId,
  });

  return { fieldset: data?.fieldset, ...rest };
};

export default useGetFieldset;
